<div class="min-h-[calc(100vh-64px)] bg-neutral-50 p-4 md:p-6 dark:bg-neutral-900 text-neutral-900 dark:text-neutral-100">
  @if (!canSeeOrderV2()) {
  } @else {
  @if (loading()) {
    <div class="flex justify-center py-10">
      <app-loading size="large" color="primary" />
    </div>
  }

  @if (successMsg(); as msg) {
    <app-alert type="success" icon="x-circle" class="mb-4">{{ msg }}</app-alert>
  }

  @if (error(); as errorMessage) {
    <app-alert type="danger" icon="x-circle" class="mb-4">{{ errorMessage }}</app-alert>
  }

  @if (data(); as order) {
    <div class="mb-3 flex justify-end">
      <app-button
        color="dark"
        size="small"
        icon="code"
        [disabled]="!realtimeReady()"
        [loading]="realtimeLoading()"
        (buttonClick)="openRealtimeModal()">
        @if (realtimeLoading()) {
          Carregando realtime…
        } @else {
          Consultar pedido Vtex
        }
      </app-button>
    </div>

    <app-realtime-json-modal #realtimeModal [data]="realtimeData()" />

    <div class="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_340px] gap-5 items-start">

      <div class="flex flex-col gap-4 min-w-0">
        <app-order-v2-header
          [orderId]="order.orderId"
          [groupOrderIds]="order.groupOrderIds"
          [orderType]="order.orderType"
          [status]="order.status"
          [statusLabel]="order.statusLabel"
          [createdAt]="order.createdAt"
          [metadata]="order.metadata"
          [deliveryType]="order.sla.deliveryType"
          [deliveryDate]="order.sla.deliveryDate"
          [invoiceNumber]="order.invoiceNumber ?? null"
          [alertCount]="order.alerts.length" />

        @if (showApprovalWorkflow() && workflowData(); as wf) {
          <app-approval-workflow
            [workflow]="wf"
            [referenceId]="routeOrderId()"
            [canPerformActions]="canPerformWorkflowActions()"
            name="Reprocessamento de Nota Fiscal"
            [description]="'A solicitação de reprocessamento para o pedido ' + order.orderId + ' foi enviada e aguarda aprovação.'"
            (workflowUpdated)="onWorkflowUpdated($event)"
            (workflowCancelled)="onWorkflowCancelled()" />
        }

        <app-integration-alerts
          [alerts]="order.alerts"
          [reprocess]="reprocess()"
          (reprocessInvoice)="openReprocessModal()" />

        <app-order-v2-timeline
          [events]="timeline()"
          [kruzerEvents]="kruzerTimeline()"
          [loading]="timelineLoading()" />

        <app-order-v2-items [items]="order.items" />

        <app-logistics-section
          [modality]="order.modality"
          [deliveryDate]="order.deliveryDate"
          [sla]="order.sla"
          [address]="order.deliveryAddress"
          [expeditionLocation]="order.expeditionLocation"
          [replenishmentLocation]="order.replenishmentLocation" />
      </div>

      <div class="flex flex-col gap-4">
        <app-financial-summary [financial]="order.financial" />
        <app-payments-list [payments]="order.payments" />
        <app-customer-card [customer]="order.customer" />
        @if (order.orderType === '3P') {
          <app-partner-card [partner]="order.partner" />
        }
        @if (order.seller) {
          <app-seller-card [seller]="order.seller" />
        }
      </div>

    </div>
  }

<app-modal #reprocessModal title="Confirmar reprocessamento" class="min-w-[900px]">
  <div class="max-h-[70vh] overflow-auto space-y-4 max-w-[1000px] mx-auto">
    <p class="text-sm text-neutral-600 dark:text-neutral-400">
      A solicitação será enviada para processamento e será executada somente após a abertura de um incidente e as devidas aprovações.
    </p>

    <input
      type="text"
      maxlength="10"
      [(ngModel)]="callNumber"
      class="flex-1 border border-neutral-300 dark:border-neutral-700 rounded px-2 py-1 text-sm bg-white dark:bg-neutral-900"
      placeholder="N chamado"
      [ngClass]="callNumber.length === 10 ? 'border-green-500' : 'border-neutral-300'" />

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <h3 class="text-sm font-semibold mb-1">Dfdl order</h3>
        <pre class="text-xs bg-neutral-100 dark:bg-neutral-800 p-2 rounded max-h-64 overflow-auto">{{ simulateDfdlOrder() }}</pre>
      </div>
      @if (simulateDfdlBilling()) {
        <div>
          <h3 class="text-sm font-semibold mb-1">Dfdl billing</h3>
          <pre class="text-xs bg-neutral-100 dark:bg-neutral-800 p-2 rounded max-h-64 overflow-auto">{{ simulateDfdlBilling() }}</pre>
        </div>
      }
    </div>

    <div class="flex justify-end gap-3">
      <app-button color="neutral" (buttonClick)="reprocessModal.closeDialog()">Cancelar</app-button>
      <app-button
        color="success"
        [disabled]="createWorkflowLoading() || callNumber.length !== 10"
        (buttonClick)="confirmReprocess()">
        @if (!createWorkflowLoading()) {
          Solicitar workflow
        } @else {
          <span class="flex items-center gap-2">
            <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none" />
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
            </svg>
            Criando…
          </span>
        }
      </app-button>
    </div>
  </div>
</app-modal>
  }
</div>
